import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.496 9.78c0 .468-.39.835-.833.835h-.834l.018 4.172a1.665 1.665 0 0 1-1.666 1.675H5.836c-.92 0-1.667-.747-1.667-1.667v-4.18h-.836A.823.823 0 0 1 2.5 9.78c0-.234.078-.443.26-.625l6.678-5.82c.182-.183.39-.209.573-.209s.39.052.547.182l6.652 5.847c.208.182.312.39.286.625m-5.829-.821c0-.92-.747-1.667-1.666-1.667-.92 0-1.667.747-1.667 1.667S9.08 10.626 10 10.626c.919 0 1.666-.748 1.666-1.667m-2.5 2.5a2.083 2.083 0 0 0-2.083 2.084c0 .229.187.416.416.416h5c.23 0 .418-.187.418-.416a2.083 2.083 0 0 0-2.084-2.084z"
    }, null, -1)
  ]))]))
}
export default { render: render }